<template>
    
</template>

<script>
export default {
   name:'Logout' ,
   created(){
        this.$store.dispatch('auth/logout')
        .then(response => {
            this.$router.push({name:'Login'})
        })
   }
}
</script>
